import { createFileRoute } from '@tanstack/react-router'
import { ModelingApp } from '../components/ModelingApp'

export const Route = createFileRoute('/')({
  component: Index,
})

function Index() {
  return <ModelingApp />
} 